export const VALID_IMAGE_SIZE_PERCENTAGE_FOR_A_BOUNDINGBOX = 0.2;
export const VALID_LATERALITY_OFFSET_PERCENTAGE_FOR_A_BOUNDINGBOX = 0.1;
export const VALID_MAX_WIDTH_IMAGE_PERCENTAGE_FOR_A_BOUNDINGBOX = 0.95;
